module.exports = __webpack_public_path__ + "img/2x3.05da3460.svg";